import { useSelector } from 'react-redux';
import {
  getGamificationLenderScope,
  getGamificationRacInScope,
  getIsGamificationEnabled,
} from 'store/selectors/auth.selector';
import { getCurrentLenderDbId } from 'store/selectors/lenders.selector';

import { useIsRacContext } from './useIsRacContext';

export const useIsGamificationVisibleHere = (): boolean => {
  const enabled = useSelector(getIsGamificationEnabled);
  const scope = useSelector(getGamificationLenderScope);
  const racInScope = useSelector(getGamificationRacInScope);
  const currentLenderId = useSelector(getCurrentLenderDbId);
  const isRacContext = useIsRacContext();

  if (!enabled) return false;

  if (scope === null) return true;

  if (isRacContext) return racInScope;

  if (currentLenderId === null) return false;

  return scope.includes(currentLenderId);
};
